import Page from "@/lib/pages/Page";
import {Modal, Pressable, StyleSheet, View} from "react-native";
import {Image} from "expo-image";
import {BASE_URL} from "@/lib/constants";

type Props = {
    thumbnailId: string | null,
    thumbnails: string[],
    onThumbnailClick: (thumbnail: string | null) => any,
}

export default function Carousel({thumbnailId, thumbnails, onThumbnailClick}: Props) {
    return (
        <Modal
            visible={thumbnailId !== null}
            allowSwipeDismissal={true}
            onDismiss={() => onThumbnailClick(null)}
            onRequestClose={() => onThumbnailClick(null)}
            animationType={"slide"}
            presentationStyle={"pageSheet"}
        >
            <Page>
                <Pressable onPress={() => onThumbnailClick(null)} style={styles.imagePreview}>
                    <Image source={thumbnailURL(thumbnailId)} style={styles.imagePreview}/>
                </Pressable>
                <View style={styles.thumbnailSelector}>
                    {thumbnails.map(t => (
                        <Pressable key={t} onPress={() => onThumbnailClick(t)} style={styles.thumbnail}>
                            <Image source={thumbnailURL(t)} style={styles.thumbnail}/>
                        </Pressable>
                    ))}
                </View>
            </Page>
        </Modal>
    )
}

function thumbnailURL(thumbnailID: string | null): string | null {
    if (thumbnailID === null) {
        return null;
    }
    return BASE_URL + `/f/originals/${thumbnailID}.webp`;
}

export const styles = StyleSheet.create({
    chatLog: {
        flexDirection: "column",
        gap: 6,
    },
    imagePreview: {
        flex: 1,
        borderRadius: 8,
    },
    thumbnailSelector: {
        height: 100,
        width: "100%",
        marginHorizontal: "auto",
        overflowX: "scroll",
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: 8,
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
    },
    thumbnail: {
        width: 100,
        height: 100,
        borderRadius: 8,
    }
})